import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { ArrowRight, TrendingDown } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export function Hero() {
  const navigate = useNavigate();
  const goSimulador = () => navigate("/simulador");
  const goDemo = () => navigate("/demo");

  return (
    <section className="relative min-h-[calc(100vh-64px)] flex items-center overflow-hidden gradient-blur-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 lg:py-0">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 place-items-center">
          {/* Texto centralizado */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-8 text-center lg:text-left"
          >
            <div className="space-y-5">
              <Badge variant="secondary" className="px-4 py-1.5 inline-flex items-center justify-center">
                <TrendingDown className="w-3 h-3 mr-1" />
                Economia Garantida
              </Badge>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-balance leading-tight">
                Descubra o Valor Real de{" "}
                <span className="text-primary">Carros de Leilão</span>
              </h1>

              <p className="text-lg sm:text-xl text-muted-foreground text-balance max-w-xl mx-auto lg:mx-0">
                Simule o alvo de lance em segundos com base na FIPE. Análise inteligente para comprar com segurança.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button size="lg" onClick={goSimulador} className="group text-base px-8">
                Analisar Carro Grátis
                <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button size="lg" variant="outline" onClick={goDemo} className="text-base px-8">
                Ver Demonstração
              </Button>
            </div>
          </motion.div>

          {/* Vídeo de animação estilo Tractable */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="w-full flex justify-center"
          >
            <div className="w-full max-w-[640px] relative">
              <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-accent/20 rounded-2xl blur-3xl -z-10" />
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full rounded-2xl shadow-2xl border border-border/50"
                poster="/placeholder.svg"
              >
                <source
                  src="https://tractable.ai/wp-content/uploads/2024/12/Tractable-Home-Our-Technology.mp4"
                  type="video/mp4"
                />
                Seu navegador não suporta vídeos HTML5.
              </video>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
